import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { GraduationCap, LayoutDashboard, LogOut, Shield, Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0C0D12]/80 backdrop-blur-2xl border-b border-white/10 saturate-150">
      <nav className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-md bg-[#00E5FF] flex items-center justify-center">
            <GraduationCap className="w-5 h-5 text-black" />
          </div>
          <span className="font-heading font-bold text-lg tracking-tight">Capacita<span className="text-[#00E5FF]">Pro</span></span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link to="/cursos" data-testid="navbar-catalog-link" className="font-body text-sm text-[#8A8D98] hover:text-white transition-colors">Cursos</Link>
          <a href="/#categorias" className="font-body text-sm text-[#8A8D98] hover:text-white transition-colors">Categorías</a>
          <a href="/#por-que" className="font-body text-sm text-[#8A8D98] hover:text-white transition-colors">¿Por qué nosotros?</a>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Button data-testid="navbar-admin-link" onClick={() => navigate("/admin")} variant="ghost" className="text-[#8A8D98] hover:text-white hover:bg-white/5">
                  <Shield className="w-4 h-4 mr-2" /> Admin
                </Button>
              )}
              <Button data-testid="navbar-dashboard-link" onClick={() => navigate("/dashboard")} variant="ghost" className="text-white hover:bg-white/5">
                <LayoutDashboard className="w-4 h-4 mr-2" /> Mi Panel
              </Button>
              <Button data-testid="navbar-logout-btn" onClick={doLogout} variant="ghost" size="icon" className="text-[#8A8D98] hover:text-white hover:bg-white/5">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button data-testid="navbar-login-btn" onClick={() => navigate("/login")} variant="ghost" className="text-white hover:bg-white/5">Ingresar</Button>
              <Button data-testid="navbar-register-btn" onClick={() => navigate("/register")} className="bg-[#00E5FF] text-black font-semibold hover:bg-white rounded-md">Empezar ahora</Button>
            </>
          )}
        </div>

        <button data-testid="navbar-mobile-toggle" className="md:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#0C0D12] border-t border-white/10 px-6 py-4 flex flex-col gap-3">
          <Link to="/cursos" onClick={() => setOpen(false)} className="font-body text-sm text-[#8A8D98]">Cursos</Link>
          {user ? (
            <>
              <Link to="/dashboard" onClick={() => setOpen(false)} className="font-body text-sm text-white">Mi Panel</Link>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="font-body text-sm text-white">Admin</Link>}
              <button onClick={doLogout} className="text-left font-body text-sm text-[#8A8D98]">Cerrar sesión</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="font-body text-sm text-white">Ingresar</Link>
              <Link to="/register" onClick={() => setOpen(false)} className="font-body text-sm text-[#00E5FF]">Empezar ahora</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
